export const CONTROLLER = {
  USERS: "User",
  DOCUMENTS: "Documents",
  DOCUMENT: "Document",
  MASTERDATA: "MasterData",
  REPORT: "Report",
  ADMIN: "Admin",
  GDX: "gdx",
  GDX_DATABASE: "gdx/database",
  GDX_BATCH_UPLOAD: "gdx/queue/api/document-analysis/database"
};

export const METHOD = {
  ME: "Me",
  UPLOAD: "Upload",
  ACCESS_DETAILS: "AccessDEtails",
  STATUS: "Status",
  REWRITE_DETAILS: "RewriteDetails",
  REQUIREMENTS: "Requirements",
  LOGOUT: "logout",
  SESSION: "session",
  DELETE_MULTIPLE_TAG: "DeleteMultipleTag",
  TAGS: "Tags",
  TAG: "Tag",
  ORIGINAL: "Original",
  DOWNLOAD: "Download",
  REWRITTEN_REQUIREMENTS: "RewrittenRequirements",
  CFIHOSMASTEROBJECTS: "CFIHOSMasterObjects",
  FAILEDRULES: "FailedRules",
  REWRITE: "Rewrite",
  LIST: "List",
  RULES: "Rules",
  RECOMMENDED_TAGS: "RecommendedTags",
  REQUIREMENT_RECOMMENDED_TAGS: "RequirementRecommendedTags",
  SEARCH_TAGS: "SearchTags",
  FINALIZE: "Finalize",
  REFERENCES: "References",
  REVERT: "Revert",
  RUN: "Run",
  TAG_OVERVIEW: "TagOverview",
  TAG_OVERVIEW_LIST: "TagOverviewList",
  TAG_DETAILS: "TagDetails",
  RULES_OVERVIEW: "RulesOverview",
  RULE_OVERVIEW_LIST: "RuleOverviewList",
  RULE_DETAILS: "RuleDetails",
  TOP_TAGS_OVERVIEW: "TopTagsOverview",
  TOP_RULES_OVERVIEW: "TopFailedRulesOverview",
  DETECTED_RULES_LIST: "DetectedRulesList",
  DETECTED_TAGS_LIST: "DetectedTagsList",
  SIMILAR_REQUIREMENTS: "SimilarRequirements",
  METRICS_TIMELINE: "MetricsTimeline",
  EXPORT: "Export",
  DELETE_REQUIREMENT_AND_REWRITTEN: "DeleteRequirementAndReWritten",
  HIERARCHY: "Hierarchy",
  RESET: "Reset",
  REORDER: "Reorder",
  GET_CONTEXT_STATEMENT: "GetContextStatement",
  RE_EVALUATE_SIMILAR_REQUIREMENTS: "ReEvaluateSimilarRequirement",
  UPDATE_DOCUMENT: "UpdateDocument",
  DOWNLOAD_SIMILAR_REQUIREMENT_DETAILS: "DownloadSimilarRequirementDetails",
  NON_EXISTENT_GP: "NonExistentGPs",
  SIMILARITY_SEARCH: "SimilaritySearch",
  NOTES: "Notes",
  EQUIPMENT_IDS: "EquipmentIds"
};
export const QUERY = {
  REFERENCE_ID: "referenceId",
  FROM_DATE: "FromDate",
  TO_DATE: "ToDate",
  FILTER: "Filter",
  RESPONSE_COUNT: "ResponseCount",
  TYPE: "Type",
  PAGE: "Page",
  SIZE: "Size",
  TAG_ID: "TagId",
  RULE_ID: "RuleId",
  SORT: "Sort",
  DIR: "Dir",
  SEARCH: "Search",
  DETECTED_TYPE: "DetectedType",
  CFIHOS_MASTER_ID: "cfihosMasterId",
  SEARCH_TEXT: "searchText",
  NO_OF_RECORDS: "noOfRecords",
  IS_REFERENCE_DOCUMENT: "isReferenceDocument",
  REFERENCE_TYPE: "referenceType",
  IS_VALID_DOCUMENT: "isValidDocument",
  GP_NAME: "gpName",
  HAS_DUPLICATE: "hasDuplicate",
  DOCUMENT_GUID: "DocumentGuidCode"
};
